import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroCarousel from "./components/HeroCarousel";
import AboutSection from "./components/AboutSection";
import ClientsSection from "./components/ClientsSection";
import EnquiryForm from "./components/EnquiryForm";
import Footer from "./components/Footer";
import LiveChat from "./components/LiveChat";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div>
      <Header />
      <HeroCarousel />
      <AboutSection />
      <ClientsSection />
      <EnquiryForm />
      <Footer />
      <LiveChat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
